
export const CHANGE_ROUTE_INFO = 'CHANGE_ROUTE_INFO';

export const LOGIN_STATE = 'LOGIN_STATE';

export const MAIL = 'MAIL';




